import { Alert } from "@mantine/core";
import { generatePath, Link, useParams } from "react-router";
import { AlertPresets } from "../../../../mantine/mantinePresets";
import { ROUTES } from "../../../../routes";

interface VollbenutzungsstundenInfoProps {
  onToggle: () => void;
}
function VollbenutzungsstundenInfo({
  onToggle
}: VollbenutzungsstundenInfoProps) {
  const { projectId } = useParams<{ projectId: string }>();
  const energyDataPath = projectId
    ? generatePath(ROUTES.energyData.entry, {
        projectId
      })
    : undefined;

  return (
    <Alert
      className="VollbenutzungsstundenInfo"
      color={AlertPresets.info.color}
      icon={AlertPresets.info.icon}
      withCloseButton
      onClose={onToggle}
    >
      opti.node berechnet automatisch die Vollbenutzungsstunden Ihrer
      KWK-Anlagen(n), sofern alle Energiedaten vorliegen. Es fehlen noch
      Datensätze? Dann ergänzen Sie diese bitte zeitnah. opti.node überprüft
      jeden Tag die vorhanden Energiedaten und beginnt die Berechnung
      automatisch, sobald diese vollständig vorliegen. Fehlende Energiedaten
      können Sie im Bereich{" "}
      {energyDataPath ? (
        <Link to={energyDataPath}>Energiedaten</Link>
      ) : (
        <strong>Energiedaten</strong>
      )}{" "}
      hochladen.
    </Alert>
  );
}

export { VollbenutzungsstundenInfo };
